<div class="liner-origin-service-form-page">
  <form [formGroup]="originServiceForm">
    <mat-card>
      <mat-card-content style="text-align: end;">
        <mat-hint style="color: red;">{{showStatus}} </mat-hint>
        @if (showDeactivateToggle) {
          <mat-slide-toggle (change)="openDeactivateForm($event)" [(ngModel)]="checked"
          [ngModelOptions]="{standalone: true}">Deactivate Liner Origin</mat-slide-toggle>
        }
        @if (showReactivateToggle) {
          <mat-slide-toggle (change)="openReactivateForm($event)" [(ngModel)]="checked"
          [ngModelOptions]="{standalone: true}" >Reactivate Liner Origin</mat-slide-toggle>
        }
      </mat-card-content>
      <mat-card-content>
        <mat-form-field>
          <mat-label>Origin/ICD</mat-label>
          <mat-select formControlName="originId" placeholder="Select Origin" required>
            <mat-option>
              <ngx-mat-select-search  [searching]="searching" [formControl]="destinationSearchCtrl"
                noEntriesFoundLabel="'no matching found'" placeholderLabel="Find Origin">
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option [value]="null">None</mat-option>
            @for (d of filteredDestinations | async; track d) {
              <mat-option [value]="d.id">
                {{ d.name }} ({{d.code}})
              </mat-option>
            }
          </mat-select>
          @if (originId.touched && originId.invalid && originId.hasError('required')) {
            <mat-error>Origin/ICD is Required</mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>Origin/ICD Type</mat-label>
          <input matInput formControlName="originType" readonly>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Line</mat-label>
          <mat-select formControlName="lineId" placeholder="Select Line" required="true">
            <mat-option>
              <ngx-mat-select-search  [searching]="searching" [formControl]="lineSearchCtrl"
                noEntriesFoundLabel="'no matching found'" placeholderLabel="Find Line">
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option [value]="null">None</mat-option>
            @for (item of filteredLines | async; track item) {
              <mat-option [value]="item.id">
                {{ item.name }} ({{item.code}})
              </mat-option>
            }
          </mat-select>
          @if (lineId.touched && lineId.invalid && lineId.hasError('required')) {
            <mat-error>Line is Required</mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>Consortium</mat-label>
          <mat-select formControlName="consortiumId" placeholder="Select Consortium" required>
            <mat-option>
              <ngx-mat-select-search  [searching]="searching" [formControl]="consortiumSearchCtrl"
                noEntriesFoundLabel="'no matching found'" placeholderLabel="Find Consortium">
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option [value]="null">None</mat-option>
            @for (c of filteredConsortium | async; track c) {
              <mat-option [disabled]="c.status=='DEACTIVATED'" [value]="c.parentId">
                {{c.name}}
              </mat-option>
            }
          </mat-select>
          @if (consortiumId.touched && consortiumId.invalid && consortiumId.hasError('required')) {
            <mat-error>Consortium is Required</mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>POL</mat-label>
          <mat-select formControlName="polId" placeholder="Select POL" required>
            <mat-option>
              <ngx-mat-select-search  [searching]="searching" [formControl]="polSearchCtrl"
                noEntriesFoundLabel="'no matching found'" placeholderLabel="Find POL">
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option [value]="null">None</mat-option>
            @for (cd of filteredConsortiumDest | async; track cd) {
              <mat-option [disabled]="cd.deactivated" [value]="cd.destinationId">
                {{cd.destinationName}} ({{cd.destinationCode}})
              </mat-option>
            }
          </mat-select>
          @if (polId.touched && polId.invalid && polId.hasError('required')) {
            <mat-error>POL is Required</mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>Mode</mat-label>
          <mat-select formControlName="mode" placeholder="Select Mode" required>
            <mat-option [value]="null">None</mat-option>
            @for (m of modes; track m) {
              <mat-option [value]="m">
                {{m}}
              </mat-option>
            }
          </mat-select>
          @if (mode.touched && mode.invalid && mode.hasError('required')) {
            <mat-error>Mode is Required</mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>Origin to POL TT</mat-label>
          <input matInput type="number" min="1" formControlName="transitTime" placeholder="Enter Transit Time" required autocomplete="off">
          @if (transitTime.touched && transitTime.invalid && transitTime.hasError('required')) {
            <mat-error>Transit Time is Required</mat-error>
          }
          @if (transitTime.touched && transitTime.invalid && transitTime.hasError('pattern')) {
            <mat-error>Enter Valid Transit Time</mat-error>
          }
        </mat-form-field>
      </mat-card-content>
      <mat-card-content>
        <h4>Liner/Consortium Services</h4>
        <div class="service-container">
          <table class="table table-border">
            <thead class="text-nowrap fx-align-space-evenly-stretch fx-row-wrap">
              <th style="flex: 1 1 12%; box-sizing: border-box;" class="width">POL</th>
              <th style="flex: 1 1 12%; box-sizing: border-box;" class="width">Destination</th>
              <th style="flex: 1 1 10%; box-sizing: border-box;" class="width">Mode</th>
              <th style="flex: 1 1 8%; box-sizing: border-box;" class="width">Transit Time</th>
              <th style="flex: 1 1 32%; box-sizing: border-box;" class="width">Transhipment Port</th>
              <th style="flex: 1 1 7%; box-sizing: border-box;" class="width">Deactivate Service</th>
            </thead>
            <tbody>
              @for (item of linerOriginServiceDetails.controls; track item; let i = $index) {
                <ng-container formArrayName="linerOriginServiceDetails">
                  <tr class="fx-align-space-evenly-stretch fx-row-wrap" [formGroupName]="i">
                    <td style="flex: 1 1 12%; box-sizing: border-box;">
                      <mat-form-field appearance="fill" class="readonly-wrapper">
                        <mat-select formControlName="portId" placeholder="Select POL" required>
                          <mat-option [value]="null">None</mat-option>
                          @for (item of destinations; track item) {
                            <mat-option [value]="item.id">
                              {{item.name}}
                            </mat-option>
                          }
                        </mat-select>
                        @if (linerOriginServiceDetails.controls[i].get('portId').errors?.required) {
                          <mat-error class="mt-1">
                            Required
                          </mat-error>
                        }
                      </mat-form-field>
                    </td>
                    <td style="flex: 1 1 12%; box-sizing: border-box;">
                      <mat-form-field appearance="fill" class="readonly-wrapper">
                        <mat-select formControlName="destinationId" placeholder="Select Destination" required>
                          <mat-option [value]="null">None</mat-option>
                          @for (item of destinations; track item) {
                            <mat-option [value]="item.id">
                              {{item.name}}
                            </mat-option>
                          }
                        </mat-select>
                        @if (linerOriginServiceDetails.controls[i].get('destinationId').errors?.required) {
                          <mat-error class="mt-1">
                            Required
                          </mat-error>
                        }
                      </mat-form-field>
                    </td>
                    <td style="flex: 1 1 10%; box-sizing: border-box;">
                      <mat-form-field appearance="fill" class="readonly-wrapper">
                        <mat-select formControlName="mode" placeholder="Select Mode" required>
                          <mat-option [value]="null">None</mat-option>
                          @for (item of modes; track item) {
                            <mat-option [value]="item">
                              {{item}}
                            </mat-option>
                          }
                        </mat-select>
                        @if (linerOriginServiceDetails.controls[i].get('mode').errors?.required) {
                          <mat-error class="mt-1">
                            Required
                          </mat-error>
                        }
                      </mat-form-field>
                    </td>
                    <td style="flex: 1 1 8%; box-sizing: border-box;">
                      <mat-form-field appearance="fill" class="readonly-wrapper">
                        <input matInput type="number" formControlName="transitTime" placeholder="Select Transit Time" autocomplete="off" required>
                        @if (linerOriginServiceDetails.controls[i].get('transitTime').errors?.required) {
                          <mat-error class="mt-1">
                            Required
                          </mat-error>
                        }
                        @if (linerOriginServiceDetails.controls[i].get('transitTime').errors?.pattern) {
                          <mat-error class="mt-1">
                            Enter Valid Time
                          </mat-error>
                        }
                      </mat-form-field>
                    </td>
                    <td style="flex: 1 1 32%; box-sizing: border-box;" class="transhipment-port-cell">
                      <!-- Read-only display of existing ports — mat-chip-set (unlike the
                      legacy mat-chip-list) doesn't implement MatFormFieldControl, so
                      wrapping it alone in mat-form-field throws "must contain a
                      MatFormFieldControl" on every row. -->
                      <mat-chip-set #chipList class="transhipment-port-chips">
                        @for (p of item.get('transhipmentPorts')?.value; track p; let i = $index) {
                          <mat-chip>
                            {{p.transhipmentPortName}}
                          </mat-chip>
                        }
                      </mat-chip-set>
                    </td>
                    <td style="flex: 1 1 7%; box-sizing: border-box;" [ngClass]="{'disable-deactivate':(disableSubmit)}">
                      <!-- <mat-checkbox class="icon-style" formControlName="deactivated"></mat-checkbox> -->
                      <mat-slide-toggle formControlName="deactivated"></mat-slide-toggle>
                    </td>
                  </tr>
                </ng-container>
              }
            </tbody>
          </table>
        </div>
      </mat-card-content>
      <mat-card-actions>
        @if (getSaveBtnCondition()) {
          <button mat-button color="primary" (click)="onSave()" style="width: 10%;margin-right: 10px;">Save</button>
        }
        <button mat-button color="cancel" (click)="onCancel()" style="width: 10%;">Cancel</button>
      </mat-card-actions>
      <mat-card-content style="margin-top: 3%;">
        @if (id.value) {
          <div class="audit-log">
            <button mat-stroked-button type="button" [class.active]="viewLog.value"
                (click)="viewLog.setValue(!viewLog.value)">
                <mat-icon>history</mat-icon> View Log
            </button>
          </div>
        }
        @if (viewLog.value) {
          <app-history [referenceType]="'LINER_ORIGIN'" [referenceId]="id.value"></app-history>
        }
      </mat-card-content>
    </mat-card>
  </form>
</div>
